import React, { useMemo } from "react";
import { Card } from "@/components/ui/card";
import { Activity } from "lucide-react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const AttendancePerformanceChart = ({ attendanceData }) => {
  const performanceData = useMemo(() => {
    if (!attendanceData || attendanceData.length === 0) {
      return [];
    }

    const monthlyAttendance = {};

    attendanceData.forEach((record) => {
      const monthKey = `${record.year}-${record.month}`;
      if (!monthlyAttendance[monthKey]) {
        monthlyAttendance[monthKey] = {
          count: 0,
          month: getMonthName(record.month),
          year: record.year,
        };
      }

      if (record.attendence) {
        monthlyAttendance[monthKey].count += 1;
      }
    });

    return Object.values(monthlyAttendance)
      .sort((a, b) => {
        if (a.year !== b.year) return a.year - b.year;
        return getMonthIndex(a.month) - getMonthIndex(b.month);
      })
      .map((item) => ({
        month: `${item.month}`,
        score: item.count,
      }));
  }, [attendanceData]);

  function getMonthName(monthNum) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[monthNum - 1] || "Unknown";
  }

  function getMonthIndex(monthName) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.indexOf(monthName);
  }

  return (
    <div className="w-full mt-4">
      <Card className="shadow-md rounded-lg p-4">
        <h1 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <Activity className="text-green-500" />
          Attandance Overview
        </h1>
        <div className="w-full h-60">
          <ResponsiveContainer>
            <LineChart data={performanceData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="score"
                stroke="#22C55E"
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

export default AttendancePerformanceChart;
